import React from 'react';
import { Button } from 'antd';
import { SynonymSaveResponse } from '../../../lib/api/searchDictionary';

type SaveResultBoxProps = {
  result: SynonymSaveResponse;
  onUndo?: () => void;
  isUndoing?: boolean;
};

/** 건수가 이 비율을 넘게 바뀌면 주의 표시(Q5) — 의도한 변경인지 한 번 더 보게 한다 */
const NOTABLE_CHANGE_RATIO = 0.3;

const formatCount = (count: number | null): string => (count === null ? '확인 못 함' : count.toLocaleString());

export const SaveResultBox = (props: SaveResultBoxProps): React.JSX.Element => {
  const { result, onUndo, isUndoing } = props;
  const { count } = result;
  const notable =
    count && count.before !== null && count.after !== null && count.before > 0
      ? Math.abs(count.after / count.before - 1) > NOTABLE_CHANGE_RATIO
      : false;

  return (
    <div className="save-result" role="status">
      <strong>{result.changed ? '저장했습니다 · 바로 반영됐습니다' : '바뀐 내용이 없어 저장하지 않았습니다'}</strong>
      {count && (
        <div className="preview-row">
          「{count.term}」 상품명·브랜드명 검색 건수
          <span className="count-before">{formatCount(count.before)}</span>→
          <span className="count-after">{formatCount(count.after)}</span>
          {notable && <span className="spread-note">30% 넘게 바뀌었습니다</span>}
        </div>
      )}
      {result.changed && onUndo && (
        <div className="preview-row">
          <Button size="small" loading={isUndoing} onClick={onUndo}>
            되돌리기
          </Button>
        </div>
      )}
    </div>
  );
};
